/*  React  */
import { CellContext } from '@tanstack/react-table';
import React from 'react';

/*  Objects  */
import { ListUserAccounts } from '../ListUserAccounts';

export const AccountsCell = <TData,>({
    cell,
    multipleAccounts,
    noIcon
}: CellContext<TData, unknown> & {
    multipleAccounts: boolean;
    noIcon: boolean;
}) => (
    <ListUserAccounts
        accounts={cell.getValue()}
        multipleAccounts={multipleAccounts}
        noIcon={noIcon}
    />
);
